import {Component, OnInit} from '@angular/core';
import {TimecardService} from '../../../_services/timecard.service';
import {Timecard} from '../../../_models/timecard';
import {OrganizationService} from '../../../_services/organization.service';
import {LoadingService} from '../../../_services/loading.service';
import {ModalController} from '@ionic/angular';
import {BaseTimecardWidgetComponent} from '../base-timecard-widget.component';
import {ColumnFormatterService} from '../../../_services/column-formatter.service';

@Component({
    selector: 'bb-employee-hours-widget',
    templateUrl: './employee-hours-widget.component.html',
    styleUrls: ['./employee-hours-widget.component.scss'],
})
export class EmployeeHoursWidgetComponent extends BaseTimecardWidgetComponent implements OnInit {

    constructor(
        timecardService: TimecardService,
        organizationService: OrganizationService,
        loadingService: LoadingService,
        modalController: ModalController,
        columnFormatterService: ColumnFormatterService
    ) {
        super(timecardService,
            organizationService,
            loadingService,
            modalController,
            columnFormatterService);
    }

    ngOnInit(): void {
        this.timecardService.event.subscribe(t => this.refresh());
    }

    refresh() {
        if (!!this.organization) {
            this.timecardService.getDateRangeTimecardsSearch(this.widget.parentId,
                this.selectedPickupLocations,
                null,
                this.startDate,
                this.endDate,
                null,
                null
            ).subscribe((t: Timecard[]) => {
                this.timecards = t;
                this.dataReady.emit();
                this.loading = false;
                this.error = false;
            }, () => {
                this.error = true;
                this.loading = false;
                this.timecards = null;
            });
        }
    }
}
